import { render } from "./aio-login-disable-common-usernames.vue?vue&type=template&id=37f2dbde&scoped=true"
import script from "./aio-login-disable-common-usernames.vue?vue&type=script&lang=js"
export * from "./aio-login-disable-common-usernames.vue?vue&type=script&lang=js"

import "./aio-login-disable-common-usernames.vue?vue&type=style&index=0&id=37f2dbde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f2dbde"]])

export default __exports__